export default function convertForm(component) {
  var properties = component.properties;
  var _ref = properties !== null && properties !== void 0 ? properties : {},
    values = _ref.values;
  return {
    brick: "eo-form",
    properties: {
      values: values !== null && values !== void 0 ? values : {},
      themeVariant: "elevo"
    }
  };
}
//# sourceMappingURL=convertForm.js.map